import { render, staticRenderFns } from "./DocumentLabelTag.vue?vue&type=template&id=21c9b314&"
import script from "./DocumentLabelTag.vue?vue&type=script&lang=ts&"
export * from "./DocumentLabelTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports